<template>
  <div>
      <div class="message-header">
        <IconBase
            :height="24"
            :width="24"
            :view-box="`0 0 24 24`"
            :fill="'#50C6DF'"
        >
            <IconWarning />
        </IconBase>
        <span class="message-header--text">Returning back to lobby</span>
      </div>
      <span class="lobby-text">Everyone will be returned to the lobby after </span>
      <SecTimer />
  </div>
</template>

<script>
import SecTimer from '../timer/SecTimer'
import IconBase from '../IconBase'
import IconWarning from '../icons/IconWarning'

export default {
    props: ['roomName'],
    components: {
        SecTimer,
        IconBase,
        IconWarning
    }

}
</script>

<style scoped>
.lobby-text {
    font-size: 12px;
    line-height: 15px;
    color: #E7E6FA;
    padding-left: 38px
}

.message-header{
    color: #E7E6FA;
    font-size: 15px;
    font-weight: 600;
    font-size: 18px;
    line-height: 23px;
    margin-bottom: 5px;
    display: flex;
}

.message-header--text {
    padding: 0 13px;
}
</style>